"use client";

import { createSearchClient, defaultIndex } from "@/configs/constants";
import { useAppSelector } from "@/store/hooks";
import { ReactNode, useMemo } from "react";
import { InstantSearch } from "react-instantsearch";
import { shallowEqual } from "react-redux";

export default function VendorProductsListContainer({ children }: VendorProductsListContainerProps) {
  const { algoliaAppId, algoliaSearchApiKey } = useAppSelector((state) => {
    return {
      algoliaAppId: state.config.algoliaAppId,
      algoliaSearchApiKey: state.config.algoliaSearchApiKey,
    };
  }, shallowEqual);
  const searchClient = useMemo(() => {
    return createSearchClient(algoliaAppId, algoliaSearchApiKey);
  }, [algoliaAppId, algoliaSearchApiKey]);

  return (
    <InstantSearch searchClient={searchClient} indexName={defaultIndex}>
      {children}
    </InstantSearch>
  );
}

export type VendorProductsListContainerProps = {
  children: ReactNode;
};
